import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'


const _hoisted_1 = { class: "contrainer" }
const _hoisted_2 = { style: {"width":"40%","height":"50px","background":"#fff","z-index":"1","text-align":"center","line-height":"50px","font-size":"40px","font-weight":"800","position":"relative"} }
const _hoisted_3 = ["src"]

import { onMounted, onUnmounted, ref, nextTick } from 'vue'
import announceAPI from '@/api/announceAPI'
import {Signature, AnnounceFile} from "@/common/types";

import VuePdfApp from 'vue3-pdf-app'
import 'vue3-pdf-app/dist/icons/main.css'

import { PDFDocument, PDFImage } from 'pdf-lib'


export default /*@__PURE__*/_defineComponent({
  __name: 'PDFSealPop',
  props: {
    data: {},
    title: {},
    공고순번: {}
  },
  emits: ['closePDFpop'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const htmlContentList: any = ref([])
onMounted(async() => {
  localStorage.removeItem('pdfjs.history')
  ImageList = []
  selectedImg.value = ''
  sealList = {
    사용인감: '',
    원본대조필: '',
    인감: ''
  }
  poptitle.value = props.title
    await modifyPdf()
  
  await announceAPI
    .sealAnnounceFile(props.data!.자료식별값)
    .then((res: any) => {
      selectedImg.value = '사용인감'
      sealList.사용인감 = res.data
      const url = window.URL.createObjectURL(new Blob([sealList.사용인감]))
      img.value = url
      imgStyle.value = { width: mmToPx(11) * offsetScale, height: mmToPx(14) * offsetScale }
    })
    .catch(() => {
      selectedImg.value = ''
    })
})
onUnmounted(() => {
  pdfSrc.value = ''
  htmlContentList.value = []
  renderFlag.value = true
})
const poptitle = ref('')
const allpageseal = ref(false)
const pdfSrc = ref('')
const oriPdfSrc = ref('')
const imgFile: any = ref('')
const renderFlag = ref(true)
const pdfContainer = ref()
const pdfApp = ref()
let offsetScale = 1
const img = ref('')
const selectedImg = ref('')
const imgStyle = ref({ width: 50, height: 50 })

const confirm = async() => {
  
  const existingPdf = await fetch(pdfSrc.value).then((res) => res.arrayBuffer())
  const pdfDoc = await PDFDocument.load(existingPdf);
  const pdfBytes = await pdfDoc.save();
  const pdfFile = new File([pdfBytes], props.data.원파일명, { type: 'application/pdf' });
  const param = {회원구분: props.data.자료식별값2, 파일제목: props.data.파일제목, 요청순번: null, 기존저장순번: props.data.저장순번}
  announceAPI
    .announceUploadFile(props.공고순번,param, pdfFile)
    .then((res: any) => {
      alert('날인이 완료되었습니다.');
      window.location.reload();
    })
    .catch((err: any) => {
      console.log(err);
    });
}
const modifyPdf = async () => {
  
  let pageWidth = 0
  let pageHeight = 0
  
  const response:any = await announceAPI.sealFile(props.data!.자료식별값,props.data!.저장순번);
  const pdfList = response.data;
  let blobs:any = []
  pdfList.forEach((base64Pdf: string, index: number) => {
    let mimeType = 'image/png'; // Default mime type
    let base64Data = base64Pdf;
    
    // Check if the string contains MIME type information
    if (base64Pdf.startsWith('data:')) {
      const matches = base64Pdf.match(/^data:([A-Za-z-+/]+);base64,(.+)$/);
      if (matches && matches.length === 3) {
        mimeType = matches[1];
        base64Data = matches[2];
      }
    }
    
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    console.log(mimeType, 'mimeType')
    blobs.push(new Blob([byteArray], { type: mimeType }));
  });
  const pdfDoc = await PDFDocument.create()

  pdfDoc.setProducer('ptbid')
  for (let i = 0; i < blobs.length; i++) {
    const page = pdfDoc.addPage()
    const imageBytes = await blobs[i].arrayBuffer();

    const pngImage = await pdfDoc.embedPng(imageBytes)
    const { width: w, height: h } = page.getSize()
    const scaled = pngImage.scaleToFit(w, h)
    page.drawImage(pngImage, {
      x: 0,
      y: 0,
      width: scaled.width,
      height: scaled.height
    })
    if (pageWidth == 0 && pageHeight == 0) {
      pageWidth = scaled.width
      pageHeight = scaled.height
    }
  }

  const pdfBytes = await pdfDoc.save()
  const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' })
  pdfSrc.value = await URL.createObjectURL(pdfBlob) // Vue 상태에 PDF 소스를 설정
  oriPdfSrc.value = await URL.createObjectURL(pdfBlob)
  await nextTick()
  // PDF 렌더링 플래그 설정
  renderFlag.value = false

  const div: any = document.querySelector('.contrainer')
  div.addEventListener('mousemove', moveEvent)

  const pageElement:any = await waitForTextLayer()
  offsetScale = pageWidth / pageElement[0].offsetWidth

  pdfSrc.value = await URL.createObjectURL(pdfBlob) // Vue 상태에 PDF 소스를 설정
  nextTick()
  oriPdfSrc.value = await URL.createObjectURL(pdfBlob)

  await document.getElementById('viewerContainer')!.addEventListener('scroll', () => {
    if(pdfApp.value) {
      pdfApp.value.zoomReset()
    }
  })  
}
const afterCreatedHandler = async (e: any) => {
  pdfApp.value = e
}
const moveEvent = (e: any) => {
  if (selectedImg.value == '') return
  const div: any = document.querySelector('.contrainer')
  const cursor: any = document.querySelector('.cursor')
  const textElement = e.target!.closest('.textLayer')
  if (!textElement) {
    cursor.classList.add('disabled')
    return
  } else {
    cursor.classList.remove('disabled')
    const boundingRect = div.getBoundingClientRect()
    const x = e.clientX - boundingRect.left
    const y = e.clientY - boundingRect.top
    cursor.style.left = `${x - imgStyle.value.width / 2}px`
    cursor.style.top = `${y - imgStyle.value.height / 2}px`
  }
}
const waitForTextLayer = () => {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const pageElement = document.getElementsByClassName('textLayer')
      if (pageElement.length > 0) {
        clearInterval(interval)
        resolve(pageElement)
      }
    }, 100)
  })
}
let sealList: any = {
  사용인감: '',
  원본대조필: '',
  인감: ''
}
const mmToPx = (mm: number) => mm * (96 / 25.4)
let ImageList: Signature[] = []
const addImage = async (e: any) => {
  const textLayer = e.target.closest('.textLayer')
  if (selectedImg.value == '') return
  if (!textLayer) {
    return
  }
  const pageElement = e.target.closest('.page')
  const pageNumber = pageElement.dataset.pageNumber
  const targetWidth = e.target.offsetWidth
  const targetHeight = textLayer.offsetHeight
  const boundingRect = textLayer.getBoundingClientRect()
  const x = e.clientX - boundingRect.left
  const y = e.clientY - boundingRect.top
  const existingPdf = await fetch(pdfSrc.value).then((res) => res.arrayBuffer())
  const pdfDoc = await PDFDocument.load(existingPdf)
  
  const page = pdfDoc.getPages()[pageNumber - 1]
  const { width, height } = page.getSize()
  const newX = x * (width / targetWidth) - (imgStyle.value.width / 2) * (width / targetWidth)
  const newY =
    targetHeight * (height / targetHeight) -
    y * (height / targetHeight) -
    (imgStyle.value.height / 2) * (width / targetWidth)
  const imgCnt = ImageList.length
  if (
    !ImageList.some(
      (item) =>
        item.page === pageNumber - 1 &&
        Math.abs(item.x - newX) <= 50 * (width / targetWidth) &&
        Math.abs(item.y - newY) <= 50 * (width / targetWidth)
    )
  ) {
    if (allpageseal.value) {
      for (let i = 0; i < imgFile.value.length; i++) {
        ImageList.push({
          page: i,
          x: newX,
          y: newY,
          scale: width / targetWidth,
          type: selectedImg.value,
          size: JSON.parse(JSON.stringify(imgStyle.value))
        })
      }
    } else {
      ImageList.push({
        page: pageNumber - 1,
        x: newX,
        y: newY,
        scale: width / targetWidth,
        type: selectedImg.value,
        size: JSON.parse(JSON.stringify(imgStyle.value))
      })
    }
  }
  if (imgCnt != ImageList.length) {
    drawSign()
  }
}
const removeImage = async (e: any) => {
  const textLayer = e.target.closest('.textLayer')
  if (!textLayer) {
    return
  }
  const pageElement = e.target.closest('.page')
  const pageNumber = pageElement.dataset.pageNumber
  const targetWidth = e.target.offsetWidth
  const targetHeight = e.target.offsetHeight
  const boundingRect = e.target.getBoundingClientRect()
  const x = e.clientX - boundingRect.left
  const y = e.clientY - boundingRect.top

  const existingPdf = await fetch(pdfSrc.value).then((res) => res.arrayBuffer())
  const pdfDoc = await PDFDocument.load(existingPdf)
  const page = pdfDoc.getPages()[pageNumber - 1]
  const { width, height } = page.getSize()
  const imgCnt = ImageList.length
  for (let i = 0; i < ImageList.length; i++) {
    const scaledX = x * (width / targetWidth) - (ImageList[i].size.width/2 * ImageList[i].scale)
    const scaledY =
      targetHeight * (height / targetHeight) -
      y * (height / targetHeight) -
      ImageList[i].size.height/2 * ImageList[i].scale
    if (
      ImageList[i].page === pageNumber - 1 &&
      Math.abs(ImageList[i].x - scaledX) <= ImageList[i].size.width/2 * ImageList[i].scale &&
      Math.abs(ImageList[i].y - scaledY) <= ImageList[i].size.height/2 * ImageList[i].scale
    ) {
      ImageList.splice(i, 1)
    }
  }
  if (imgCnt != ImageList.length) {
    drawSign()
  }
}
const drawSign = async () => {
  const existingPdf = await fetch(oriPdfSrc.value).then((res) => res.arrayBuffer())
  const pdfDoc = await PDFDocument.load(existingPdf)
  const form = pdfDoc.getForm();
  form.flatten();

  let makBytes: ArrayBuffer | undefined,
    wonBytes: ArrayBuffer | undefined,
    ingBytes: ArrayBuffer | undefined
  if (sealList.사용인감 != '') {
    makBytes = await sealList.사용인감.arrayBuffer()
  }
  if (sealList.원본대조필 != '') {
    wonBytes = await sealList.원본대조필.arrayBuffer()
  }
  if (sealList.인감 != '') {
    ingBytes = await sealList.인감.arrayBuffer()
  }
  let makImage: PDFImage | undefined, wonImage: PDFImage | undefined, ingImage: PDFImage | undefined
  if (makBytes) {
    makImage = await pdfDoc.embedPng(makBytes)
  }
  if (wonBytes) {
    wonImage = await pdfDoc.embedPng(wonBytes)
  }
  if (ingBytes) {
    ingImage = await pdfDoc.embedPng(ingBytes)
  }
  ImageList.forEach((dto: Signature) => {
    let image: PDFImage | undefined
    switch (dto.type) {
      case '사용인감':
        image = makImage
        break
      case '원본대조필':
        image = wonImage
        break
      case '인감':
        image = ingImage
        break
    }
    if (image) {
      const page = pdfDoc.getPages()[dto.page]
      page.drawImage(image, {
        x: dto.x,
        y: dto.y,
        width: dto.size.width * dto.scale,
        height: dto.size.height * dto.scale
      })
    }
  })
  const pdfBytes = await pdfDoc.save()
  const blob = new Blob([pdfBytes], { type: 'application/pdf' })
  pdfSrc.value = URL.createObjectURL(blob)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "cover" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(poptitle.value) + " ", 1),
      _createElementVNode("img", {
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closePDFpop'))),
        class: "close_icon"
      })
    ]),
    _createElementVNode("div", {
      ref_key: "pdfContainer",
      ref: pdfContainer,
      style: {"height":"calc(100% - 60px)"},
      class: "pdfContainer"
    }, [
      _createVNode(_unref(VuePdfApp), {
        class: "vue-pdf",
        style: {"height":"100%","width":"100%","position":"relative"},
        pdf: pdfSrc.value,
        onClick: _withModifiers(addImage, ["left"]),
        onContextmenu: _withModifiers(removeImage, ["right"]),
        onAfterCreated: afterCreatedHandler,
        oncontextmenu: "return false",
        config: {
          toolbar: false}
      }, null, 8, ["pdf"])
    ], 512),
    _createElementVNode("div", { style: {"height":"70px","width":"40%","background":"#fff","display":"flex","align-items":"center","justify-content":"center","z-index":"1"} }, [
      _createElementVNode("div", {
        style: {"width":"300px","height":"50px","border-radius":"8px","text-align":"center","line-height":"50px"},
        class: "contract_btn active",
        onClick: confirm
      }, "등록")
    ]),
    (selectedImg.value != '')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "cursor disabled",
          src: img.value,
          style: _normalizeStyle({ width: imgStyle.value.width + 'px', height: imgStyle.value.height + 'px' })
        }, null, 12, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})